import { Badge, Col, Row } from "reactstrap";
import { BadgeTitle } from "../../../Constants/Constants";
import { ElementBadgeData } from "../../../Data/Bonus/Elements";
import { Fragment } from "react/jsx-runtime";

const ElementBadge = () => {
  return (
    <section>
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{BadgeTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {ElementBadgeData.map((item, index) => (
                <Fragment key={index}>
                  <Badge className={`badge-outline-${item} sm font_label`}>R</Badge>
                  <Badge color={item} className="sm font_label">E</Badge>
                </Fragment>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default ElementBadge;
